import CheckboxItem, {
  CHECKBOX_STATES,
} from "@javascript/reactComponents/lds/selection_controls/CheckboxItem";

export default function SelectAllListsCheckbox({
  currentCount,
  numLists,
  numListsSelected,
  onClick,
}) {
  let checkboxState = CHECKBOX_STATES.unselected;

  if (numLists === numListsSelected) {
    checkboxState = CHECKBOX_STATES.selected;
  } else if (numListsSelected > 0) {
    checkboxState = CHECKBOX_STATES.indeterminate
  }

  const containerStyles = {
    flexDirection: "row-reverse",
    marginRight: "var(--space-400)"
  }

  return (
    <CheckboxItem
      id="select-all"
      label={`Select all ${currentCount} lists`}
      selection={checkboxState}
      styleOverride={{ container: containerStyles }}
      onClick={onClick}
    />
  );
}
